export default "__VITE_ASSET__CrZ6F_f___"